import { post } from "../../utils/Backend";
import { useH5Mock } from "../../global/GlobalMock";
import { qaFeedMocks } from "./QaFeedMock";
import type {
  QaEngagementParam,
  QaEngagementState,
  QaFeedListQuery,
  QaFeedListResult,
  QaFeedQuestion,
  QaQuotaQuery,
  QaQuotaResult,
  QaSubmitQuestionPayload,
  QaSubmitReplyPayload,
} from "./QaFeedType";

const mockQaFeed = useH5Mock && false;

export const QaFeedApi = {
  async listFeed(query: QaFeedListQuery): Promise<QaFeedListResult | string> {
    if (mockQaFeed) return qaFeedMocks.listFeed(query);
    return post<QaFeedListQuery, QaFeedListResult>("/lark/app/qa/listFeed", query, {
      silent: true,
    });
  },

  async submitQuestion(payload: QaSubmitQuestionPayload): Promise<QaFeedQuestion | string> {
    if (mockQaFeed) return qaFeedMocks.submitQuestion(payload);
    return post<QaSubmitQuestionPayload, QaFeedQuestion>("/lark/app/qa/submitQuestion", payload);
  },

  async quota(query: QaQuotaQuery): Promise<QaQuotaResult | string> {
    if (mockQaFeed) return qaFeedMocks.quota(query);
    return post<QaQuotaQuery, QaQuotaResult>("/lark/app/qa/quota", query, { silent: true });
  },

  async submitReply(payload: QaSubmitReplyPayload): Promise<QaFeedQuestion | string> {
    if (mockQaFeed) return qaFeedMocks.submitReply(payload);
    return post<QaSubmitReplyPayload, QaFeedQuestion>("/lark/app/qa/submitReply", payload);
  },

  async toggleLike(param: QaEngagementParam): Promise<QaEngagementState | string> {
    if (mockQaFeed) return qaFeedMocks.toggleLike(param);
    return post<QaEngagementParam, QaEngagementState>("/lark/app/qa/toggleLike", param, {
      silent: true,
    });
  },

  async toggleCollect(param: QaEngagementParam): Promise<QaEngagementState | string> {
    if (mockQaFeed) return qaFeedMocks.toggleCollect(param);
    return post<QaEngagementParam, QaEngagementState>("/lark/app/qa/toggleCollect", param, {
      silent: true,
    });
  },
};
